// Local per-user game state (Phase 1 transitional store). Pure — no Supabase
// import — so it is unit-testable and safe to reuse. Game state moves to
// Postgres table-by-table in phases 3–8; this bridge is namespaced by the
// Supabase user id and NEVER stores a password (spec §4/§5/§10).

export const CURRENT_SEASON = 2026;

export function defaultGameState(id, name) {
  return {
    id,
    name,
    avatar: "🏉",
    attended: [],
    allTimeAttended: [],
    cards: [],
    seasonBadges: [],
    allTimeBadges: [],
    tradesCompleted: 0,
    activations: 0,
    lastFreePackDate: null,
    connections: [],
    seasonYear: CURRENT_SEASON,
    supportedTeam: null,
    teamConfirmedSeason: null,
    confirmedGames: [],
    gamePlayers: {},
  };
}
